<template>
  <div>
    <TheBanner />
    <div class="part1 content">
      <h3 class="main-title" style="text-align:center">{{$t('home_25')}}</h3>
      <div class="com-w">
        <div class="com-i" style="border-right: 1px solid #D7DDE1;margin-right: 60px">
            <div class="com-i-l">
              <img src="../assets/images/com_1.png" alt="">
            </div>
            <div class="com-i-r">
              <img src="../assets/images/com_2.png" style="width: 166px;" alt="">
              <p>4.4/5  Excellent</p>
            </div>
        </div>
        <div class="com-i">
            <div class="com-i-l">
              <img src="../assets/images/com_3.png" alt="">
            </div>
            <div class="com-i-r">
              <p>{{$t('home_26')}}</p>
            </div>
        </div>
      </div>
    </div>

    <div class="part2">
      <div class="content df-colc">
        <h3 class="main-title">{{$t('home_27')}}</h3>
        <div class="c-w content">
          <SymbolList style="margin-top: 50px" @seeMore="toMarket" :home="true" />
          <div class="c-d">
            <div class="cd-item">
              <h4>{{$t('home_36')}}</h4>
              <p>{{$t('home_37')}}</p>
            </div>
            <div class="cd-item" style="margin-top: 50px">
              <h4>{{$t('home_38')}}</h4>
              <p>{{$t('home_39')}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="part3">

      <div class="p3-wrap">
        <div class="p3-l">
          <p style="height: 200px;line-height: 200px;font-family: Impact;">
            <span style="font-size: 240px;">0.9</span>
            <span style="font-size: 120px;">%</span>
          </p>
          <p style="font-size: 27px;margin-top:24px;">0.7% spreads +0.2% commissions</p>
        </div>
        <div class="p3-r">
          <h3>{{$t('home_40')}}</h3>
          <p>{{$t('home_41')}}</p>
        </div>
      </div>
      <!-- <img src="../assets/images/Home-img@2x.png" width="100%" alt=""> -->
      <!-- <div class="content">
        <div class="part3Text">
          <div>
            <p style="font-size: 40px; font-weight: bold; line-height: 50px; margin-bottom: 20px;">
              {{$t('home_13')}}
            </p>
            <p>
              {{$t('home_14')}}
            </p>
          </div>
        </div>
      </div> -->
    </div>

    <div class="part4" style="margin-top: 80px">
      <div class="content df-colc">
        <h3 class="main-title">{{$t('home_42')}}</h3>
        <div class="p4-line" style="margin-top: 50px">
          <div class="p4-item">
            <img src="../assets/images/home/p4_1.png" alt="">
            <h4>{{$t('home_43')}}</h4>
            <p>{{$t('home_44')}}</p>
          </div>
          <div class="p4-item">
            <img src="../assets/images/home/p4_2.png" alt="">
            <h4>{{$t('home_45')}}</h4>
            <p>{{$t('home_46')}}</p>
          </div>
        </div>
        <div class="p4-line">
          <div class="p4-item">
            <img src="../assets/images/home/p4_3.png" alt="">
            <h4>{{$t('home_47')}}</h4>
            <p>{{$t('home_48')}}</p>
          </div>
          <div class="p4-item">
            <img src="../assets/images/home/p4_4.png" alt="">
            <h4>{{$t('home_49')}}</h4>
            <p>{{$t('home_50')}}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="part5">
      <div class="content df-colc">
        <h3 class="main-title">{{$t('home_51')}}</h3>
        <div class="n-w">
          <div class="n-i" v-for="(item, index) in numbersDataL1" :key="index">
            <img :src="item.icon" alt="">
            <h5>{{item.number}}</h5>
            <p>{{item.typeLable}}</p>
          </div>
        </div>

        <div class="n-w">
          <div class="n-i" v-for="(item, index) in numbersDataL2" :key="index">
            <img :src="item.icon" alt="">
            <h5>{{item.number}}</h5>
            <p>{{item.typeLable}}</p>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import TheBanner from './home/TheBanner'
import TheChart from './home/TheChart'
import SymbolList from './SymbolList'

export default {
  name: 'home',
  components: { SymbolList, TheBanner, TheChart },
  computed: {
    stepList () {
      return [
        {
          topimg: require('../assets/images/Icon1@2x.png'),
          midword1: this.$t('home_16'),
          midword2: this.$t('home_17'),
        },
        {
          topimg: require('../assets/images/Icon2@2x.png'),
          midword1: this.$t('home_18'),
          midword2: this.$t('home_19'),
        },
        {
          topimg: require('../assets/images/Icon3@2x.png'),
          midword1: this.$t('home_20'),
          midword2: this.$t('home_21'),
        },
        {
          topimg: require('../assets/images/Icon4@2x.png'),
          midword1: this.$t('home_22'),
          midword2: this.$t('home_23'),
        },
      ]
    },
  },
  data() {
    return {
      numbersDataL1: [{
        icon: require('../assets/images/about/number_1.png'),
        number: this.$t('home_52'),
        type: 'Daily new clients',
        typeLable: this.$t('home_53'),
      }, {
        icon: require('../assets/images/about/number_2.png'),
        number: this.$t('home_54'),
        type: 'Active clients',
        typeLable: this.$t('home_55'),
      }, {
        icon: require('../assets/images/about/number_3.png'),
        number: this.$t('home_56'),
        type: 'Trading volume',
        typeLable: this.$t('home_57'),
      }, {
        icon: require('../assets/images/about/number_4.png'),
        number: this.$t('home_58'),
        type: 'Years in the industry',
        typeLable: this.$t('home_59'),
      }],
      numbersDataL2: [{
        icon: require('../assets/images/about/number_5.png'),
        number: this.$t('home_60'),
        type: 'Assets',
        typeLable: this.$t('home_61'),
      }, {
        icon: require('../assets/images/about/number_6.png'),
        number: this.$t('home_62'),
        type: 'Order execution',
        typeLable: this.$t('home_63'),
      }, {
        icon: require('../assets/images/about/number_7.png'),
        number: this.$t('home_64'),
        type: 'Order execution',
        typeLable: this.$t('home_65'),
      }, {
        icon: require('../assets/images/about/number_8.png'),
        number: this.$t('home_66'),
        type: 'Order execution',
        typeLable: this.$t('home_67'),
      }]
    }
  },
  methods: {
    toMarket(){
      this.$emit('toMarket')
    }
  }
}
</script>

<style scoped lang="scss">
.part1{
  background: #FFFFFF;
  border-radius: 12px;
  border: 1px solid #D7DDE1;
  padding: 30px 140px;
  margin-top: 80px;
  .com-w{
    display: flex;
    margin-top: 40px;
    .com-i{
      flex: 1;
      display: flex;
      align-items: center;
      .com-i-l{
        margin-right: 60px;
        img{
          width: 132px;
          height: 80px;
        }
      }
      .com-i-r{
        p{
          font-size: 16px;
          font-weight: 400;
          color: #000000;
          line-height: 24px;
        }
      }
    }
  }
}
.part2 {
  padding: 60px 120px;
}

.part2Title {
  font-size: 28px;
  line-height: 40px;
  margin-bottom: 40px;
  font-family: Roboto-Bold;
  text-align: center;
}

.steps,
.stepItem,
.part3Text {
  display: flex;
  align-items: center;
}

.part4 {
  margin-bottom: 60px;
  .p4-line{
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 20px;
    .p4-item{
      width: 580px;
      background: #FFFFFF;
      border-radius: 12px;
      border: 1px solid #D7DDE1;
      padding: 20px 20px 32px 20px;
      h4{
        margin-top: 20px;
        padding-left: 10px;
      }
      p{
        padding-left: 10px;
        margin-top: 10px;
      }
      img{
        width: 540px;
        height: 160px;
      }
    }
  }
}

.steps {
  padding-top: 40px;
}

.stepBox {
  margin-left: 25px;
}

.stepLeft {
  margin-left: 50px;
  position: relative;
}

.stepTitle {
  margin-bottom: 60px;
  font-size: 28px;
  line-height: 40px;
  color: #181D24;
  font-family: Roboto-Bold;
}

.stepItem {
  margin: 20px 0;
}

.tepWord1 {
  font-size: 18px;
  color: #181D24;
  font-family: Roboto-Bold;
}

.tepWord2 {
  font-size: 14px;
  color: #5C6E7B;
}

.part3 {
  background-image: url(../assets/images/Home-img@2x.png);
  background-repeat: no-repeat;
  background-size: 100vw 20.83vw;
  height: 20.83vw;
  color: #fff;
  font-family: Roboto-Medium, Roboto;
  .p3-wrap{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    .p3-r{
      width: 460px;
      margin-left: 80px;
      h3{
        font-size: 32px;
        font-weight: bold;
        color: #FFFFFF;
        line-height: 40px;
      }
      p{
        font-size: 16px;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 24px;
        padding-top: 30px;
      }
    }
  }
}
.c-w{
  display: flex;
  .c-d{
    width: 400px;
    margin-left: 80px;
    margin-top: 50px;
    .cd-item{
      h4{
        height: 40px;
        font-size: 24px;
        font-weight: bold;
        color: #181D24;
        line-height: 40px;
      }
      p{
        font-size: 16px;
        font-weight: 400;
        color: #5C6E7B;
        line-height: 24px;
        margin-top: 10px;
      }
    }
  }
}

.part3Text {
  height: 100%;
  color: #fff;
  font-size: 16px;
  line-height: 20px;
}


.part5{
  background: #D7DEF4;
  padding: 60px 0 80px;
}

.main-title{
  height: 40px;
  font-size: 32px;
  font-family: Roboto-Bold, Roboto;
  font-weight: bold;
  color: #181D24;
  line-height: 40px;
}

.n-w{
  display: flex;
  width: 100%;
  margin-top: 50px;
  .n-i{
    flex: 1;
    border-right: 1px solid #A6B1D5;
    margin-right: 20px;
    padding-left: 40px;
    img{
      height: 60px;
      width: 60px;
    }
    h5{
      height: 30px;
      font-size: 18px;
      font-family: Roboto-Bold, Roboto;
      font-weight: bold;
      color: #181D24;
      line-height: 24px;
      margin-top: 10px;
    }
    p{
      height: 20px;
      font-size: 16px;
      font-family: Roboto-Regular, Roboto;
      font-weight: 400;
      color: #5C6E7B;
      line-height: 14px;
    }
  }
  .n-i:nth-child(4){
    border: none;
    margin-right: 0;
  }
}

.df-colc{
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue